import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;
	padding-bottom: 1rem;
`;

export const bigImg = styled.div`
	width: 100%;
	padding: 0 8px;
	> img {
		width: 100%;
		border-radius: 5px;
		background-color: ${color.interface.lightGray2};
	}
`;

export const video = styled.video`
	width: 100%;
	padding: 0 8px;
	border-radius: 5px;
`;

export const box = styled.div`
	width: 100%;
	padding: 0 8px;
`;

export const carrosselWithTitle = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: center;
	justify-content: flex-start;
	padding: 0 8px;

	> h1 {
		width: 100%;
		text-align: left;
		font-size: 1.6rem;
		font-family: nunito-bold;
		color: ${color.interface.white};
	}
`;
